import { render, staticRenderFns } from "./qrInfo.vue?vue&type=template&id=058d1b94&scoped=true&"
import script from "./qrInfo.vue?vue&type=script&lang=js&"
export * from "./qrInfo.vue?vue&type=script&lang=js&"
import style0 from "./qrInfo.vue?vue&type=style&index=0&id=058d1b94&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "058d1b94",
  null
  
)

export default component.exports